import React, { startTransition } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import styles from "./ViewDocPage.module.scss";
import linkArrowLeftSvg from "../assets/images/linkArrowLeft.svg";
import EmbeddedDocument from "./EmbeddedDocument/EmbeddedDocument";

const ViewDocPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  const documentLinkFromState = location.state?.documentLink;
  const docIdFromWorkbench = location.state?.docId;
  
  // Get URL parameters
  const backUrl = searchParams.get("backurl") || "/workbench-dashboard";

  return (
    <div className={styles.content}>
      {/* Header with breadcrumb */}
      <div className={styles.mainArea}>
        <div className={styles.header}>
          <img
            src={linkArrowLeftSvg}
            alt="Back"
            style={{ verticalAlign: "middle", marginRight: 6, height: 18 }}
          />
          <span
            className={styles.breadcrumb}
            onClick={() =>
              startTransition(() => navigate(backUrl))
            }
          >
            Home
          </span>
        </div>
        <div className={styles.docWrapper}>
          <EmbeddedDocument
            useSourcingHubFlow={true}
            docIdFromWorkbench={docIdFromWorkbench}
            documentLinkFromState={documentLinkFromState}
            showBreadcrumb={false}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewDocPage;
